import type { PresenceSource } from './entry';
import { presenceSourceSchema } from './entry';
import { Joi, objectSchemaOf } from '../helpers';

export type PresenceStatus = 'online' | 'offline';

export const presenceStatusSchema = Joi.string().valid('online', 'offline');

export interface IPresenceResultEntry {
  uid: string;
  source: PresenceSource;
  picture?: string;
  displayName: string;
  checkedIn: boolean;
  status: PresenceStatus;
  lastTimestamp: number;
  sessionId: string;
  activationTimestamp: number;
}

export const presenceResultEntry = objectSchemaOf<IPresenceResultEntry>({
  uid: Joi.string().required(),
  source: presenceSourceSchema.required(),
  picture: Joi.string().optional(),
  displayName: Joi.string().required(),
  checkedIn: Joi.boolean().required(),
  status: presenceStatusSchema.required(),
  lastTimestamp: Joi.number().required(),
  sessionId: Joi.string().required(),
  activationTimestamp: Joi.number().required(),
});

export type PresenceResult = IPresenceResultEntry[];

export interface IPresenceParams {
  uid?: string;
  source?: PresenceSource;
}

export const presenceParamsSchema = objectSchemaOf<IPresenceParams>({
  uid: Joi.string().optional(),
  source: presenceSourceSchema.optional(),
});
